<template>
    <div>
        <div class="redeem-btn"
            :class="strButtonClass"
            @click="clickRedeem()"
            v-html="strButtonLabel"></div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * Property
 * @property {boolean} isLogin (required) Is user logged in.
 * @property {number} point (required) User available point.
 * @property {number} selectedPoint (required) Point amount for redeem campaign.
 * @property {number} selectedQuantity (required) Campaign's quantity.
 * @property {object} lblRedeemBTN (required) Text for component.
 * @property {object} campaign (required) Campaign data.
 * @property {object} redeemBTN (required) Redeem information (redeemable, isDisable etc.).
 *
 * Event
 * @event clickRedeem Callback to parent component when click redeem button.
 * Method
 * @method initialRedeemButton Setup redeem button data (text, redeemable, disable css class, etc.).
 *
 * Utilities
 * @method cleanRedeemButtonLabel Replace \n with <br/>.
 * @method getRedeemButtonClass Get redeem current css class.
 */

export default {
    name: "RedeemButton",
    props: {
        isLogin: Boolean,
        point: Number,
        selectedPoint: Number,
        selectedQuantity: Number,
        lblRedeemBTN: Object,
        campaign: Object,
        redeemBTN: Object,

    },
    data: function() {
        return {
            strButtonLabel: '',
            strButtonClass: '',

            tracking: new TrackingService(this),
        };
    },
    mounted: function () {
        console.log("redeemBTN");
        this.initialRedeemButton();
        this.strButtonClass = this.getRedeemButtonClass();
        this.strButtonLabel = this.cleanRedeemButtonLabel();

    },
    methods: {
        //Event
        clickRedeem: function () {
            this.tracking.event("campaign_detail", "click_redeem_campaign", this.campaign.id+"|"+this.campaign.name);

            this.$emit('clickRedeem');
        },
        //Function
        initialRedeemButton: function () {
            //Declare default stuff.
            this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.default;
            this.redeemBTN.isAllowRedeem = this.campaign.isConditionPass;
            this.redeemBTN.isButtonDisable = !this.campaign.isConditionPass;
            //Check is campaign supported.
            if(this.campaign.type == Vue.CampaignType.Bid ||
                this.campaign.type == Vue.CampaignType.Media) {
                this.redeemBTN.isAllowRedeem = false;
                this.redeemBTN.isButtonDisable = true;
                this.redeemBTN.strDisableClass = 'redeem-notsupport';
                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.notSupport;
                return;
            }
            if (this.campaign.type == Vue.CampaignType.Event) {

                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.specialEvent;
            }
            //Check expire date.
            if(this.campaign.currentDate > this.campaign.expireDate) {
                this.redeemBTN.isAllowRedeem = false;
                this.redeemBTN.isButtonDisable = true;
                this.redeemBTN.strDisableClass = 'redeem-expired';
                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                return;
            }
            //Check sold out.
            if(this.selectedQuantity <= 0) {
                this.redeemBTN.isAllowRedeem = false;
                this.redeemBTN.isButtonDisable = true;
                this.redeemBTN.strDisableClass = "redeem-soldout";
                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                return;
            }
            //Do validate when logged in.
            if(this.isLogin) {
                //Check user enough point.
                if(this.selectedPoint > this.point) {
                    if(this.campaign.pointType && this.campaign.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        this.redeemBTN.isAllowRedeem = false;
                        this.redeemBTN.isButtonDisable = true;
                        this.redeemBTN.strDisableClass = 'redeem-notenoughpoint';
                        this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.notEnoughPoint;
                        return;
                    }
                }
                //Handle common case for custom text.
                if(!this.campaign.isConditionPass && this.campaign.type != Vue.CampaignType.Event) {


                    this.redeemBTN.isAllowRedeem = false;
                    this.redeemBTN.isButtonDisable = true;
                    //Use api text message.
                    if(this.redeemBTN.isUseDefault) {
                        this.redeemBTN.strDisableClass = 'redeem-condition';
                        this.redeemBTN.strRedeemLabel = this.campaign.conditionAlert;
                    } else {
                        switch(this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.none;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.redeemBTN.strDisableClass = "redeem-soldout";
                                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.redeemBTN.strDisableClass = "redeem-maxperson";
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.redeemBTN.strDisableClass = "redeem-cooldown";
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.redeemBTN.strDisableClass = "redeem-eligible";
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.redeemBTN.strDisableClass = "redeem-expired";
                                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignNotAvailableBuy : this.lblRedeemBTN.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.redeemBTN.strDisableClass = "redeem-condition";
                                this.redeemBTN.strRedeemLabel = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.redeemBTN.strDisableClass = 'redeem-allow';

                    if(this.campaign.customCaption) {
                        this.redeemBTN.strRedeemLabel = this.campaign.customCaption;
                    }
                }
            } else {
                this.redeemBTN.strDisableClass = 'redeem-allow';

                if(this.campaign.customCaption) {
                    this.redeemBTN.strRedeemLabel = this.campaign.customCaption;
                }
            }
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.redeemBTN.strRedeemLabel);
        },
        getRedeemButtonClass: function () {
            if(!this.redeemBTN.isAllowRedeem)
                return this.redeemBTN.strDisableClass;

            return 'redeem-allow';
        }
    }

}
</script>
<style lang="scss">
.redeem-btn {


    width: calc(100% - 30px);
    padding: 10px 10px;
    background-color: black;
    color: white;
    text-align: center;
    font-size: 1rem;
    padding: 10px 15px;
    position: absolute;
    bottom: 10px;
}
</style>
